export let TRANSCODING_STATUSES = /*#__PURE__*/function (TRANSCODING_STATUSES) {
  TRANSCODING_STATUSES["IN_QUEUE"] = "IN-QUEUE";
  TRANSCODING_STATUSES["PENDING"] = "PENDING";
  TRANSCODING_STATUSES["INPROGRESS"] = "INPROGRESS";
  TRANSCODING_STATUSES["PREVIEW_READY"] = "PREVIEW_READY";
  TRANSCODING_STATUSES["READY"] = "READY";
  TRANSCODING_STATUSES["FAILED"] = "FAILED";
  TRANSCODING_STATUSES["NONE"] = "NONE";
  return TRANSCODING_STATUSES;
}({});
//# sourceMappingURL=transcoding-statuses.js.map